const asbestosServices = [
  {
    icon: 'ri-search-eye-line',
    title: 'Asbestos Inspection',
    desc: 'Thorough visual inspection of all suspect areas and materials by certified asbestos inspectors. Required before any renovation or demolition work.',
    img: 'https://public.readdy.ai/ai/img_res/73f08dd8bf8fe99f4332d0b401bd7f3f.jpg',
    step: '01',
  },
  {
    icon: 'ri-test-tube-line',
    title: 'Laboratory Testing',
    desc: 'Air and bulk material samples sent to accredited labs for fiber identification. Written reports confirm presence, type, and recommended action.',
    img: 'https://readdy.ai/api/search-image?query=laboratory%20environmental%20scientist%20using%20phase%20contrast%20microscope%20to%20analyze%20asbestos%20fiber%20air%20sample%20on%20glass%20slide%20clean%20professional%20lab%20setting%20sample%20cassettes%20and%20testing%20equipment%20on%20lab%20bench%20EPA%20NVLAP%20certified%20analysis%20documentary%20style%20clinical%20lighting%20muted%20clean%20tones&width=500&height=360&seq=ecos-asb-svc3-002&orientation=landscape',
    step: '02',
  },
  {
    icon: 'ri-shield-line',
    title: 'Certified Safe Removal',
    desc: 'Licensed abatement workers execute removal using full containment, HEPA filtration, and strict PPE protocols. Zero cross-contamination.',
    img: 'https://readdy.ai/api/search-image?query=two%20asbestos%20abatement%20workers%20in%20white%20Tyvek%20full-body%20suits%20gloves%20and%20respirators%20carefully%20bagging%20and%20double-sealing%20asbestos-containing%20floor%20tiles%20with%20heavy%20duty%20polyethylene%20bags%20labeled%20HAZARDOUS%20inside%20containment%20zone%20professional%20safe%20removal%20procedure%20moody%20dramatic%20interior%20lighting%20documentary%20photography%20dark%20tones&width=500&height=360&seq=ecos-asb-svc3-003&orientation=landscape',
    step: '03',
  },
  {
    icon: 'ri-truck-line',
    title: 'Regulated Disposal',
    desc: 'All asbestos waste transported and disposed of at EPA-approved facilities with complete chain-of-custody documentation and manifests.',
    img: 'https://readdy.ai/api/search-image?query=hazardous%20waste%20disposal%20workers%20loading%20sealed%20double-bagged%20asbestos%20waste%20into%20licensed%20hazardous%20material%20disposal%20truck%20with%20HAZMAT%20warning%20signage%20industrial%20loading%20dock%20early%20morning%20light%20professional%20documentary%20muted%20earth%20tones%20safety%20compliance%20EPA%20regulated%20waste%20transport%20professional%20crew&width=500&height=360&seq=ecos-asb-svc3-004&orientation=landscape',
    step: '04',
  },
];

export default function AsbestosServicesOverview() {
  return (
    <section className="bg-white py-28">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 mb-16 items-end">
          <div className="lg:col-span-6">
            <p className="text-ecos-green text-xs uppercase tracking-widest font-semibold mb-4">Service Scope</p>
            <h2 className="font-serif text-ecos-charcoal text-4xl lg:text-5xl font-semibold leading-tight">
              Complete Asbestos Abatement — Inspection to Clearance
            </h2>
          </div>
          <div className="lg:col-span-6 flex items-end">
            <p className="text-ecos-text text-base leading-relaxed">
              ECOS Environmental handles every phase of certified asbestos abatement in-house — from initial inspection through post-clearance air testing. One team, complete accountability, zero handoffs.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5">
          {asbestosServices.map((svc) => (
            <div key={svc.title} className="group border border-ecos-border rounded-sm overflow-hidden hover:border-ecos-green transition-all duration-300 hover:-translate-y-1 cursor-default">
              <div className="w-full h-48 overflow-hidden relative">
                <img
                  src={svc.img}
                  alt={`${svc.title} — ECOS Environmental Colorado`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-700"
                />
                <div className="absolute top-4 left-4 bg-ecos-charcoal/85 text-white text-xs font-mono font-semibold px-3 py-1 rounded-sm">
                  Step {svc.step}
                </div>
              </div>
              <div className="p-6">
                <div className="flex items-center gap-3 mb-3">
                  <div className="w-9 h-9 flex items-center justify-center bg-ecos-green-pale rounded-sm flex-shrink-0">
                    <i className={`${svc.icon} text-ecos-green text-base`}></i>
                  </div>
                  <h3 className="font-serif text-ecos-charcoal text-base font-semibold group-hover:text-ecos-green transition-colors">{svc.title}</h3>
                </div>
                <p className="text-ecos-text text-sm leading-relaxed">{svc.desc}</p>
              </div>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
}
